import { graphql } from "gql.tada";

export const StepRuleSetFieldsFragment = graphql(`
  fragment StepRuleSetFields on StepRuleSetModel {
    id
    version
    presetName
    teamCount
    validated
    validatedAt
    createdAt
    updatedAt
    scoringRuleSet {
      id
      aggregation
      formula
      winPoints
      lossPoints
      drawPoints
      forfeitPoints
      tiebreakers {
        id
        order
        type
        formula
        sortOrder
      }
    }
    advancementRules {
      id
      name
      description
      order
      triggerType
      triggerScope
      condition
      actions {
        type
        script
      }
      autoExecute
      allowManualOverride
      enabled
      purpose
      createdAt
      updatedAt
    }
    crossStepRules {
      id
      sourceStepId
      sourceRelative
      dataSource
      usage {
        type
        condition
        formula
      }
    }
    structureTemplate {
      id
      groupTemplates {
        id
        name
        description
        order
        teamSlotsExpr
        generationScript
        bestOfExpr
        teamSlotsPerGameExpr
        roundCountExpr
        roundTemplates {
          id
          name
          order
          gameTemplates {
            id
            order
            teamSlots
            bestOf
            onWinTarget
            onWinSourceSlot
            onWinTargetSlot
            onLossTarget
            onLossSourceSlot
            onLossTargetSlot
          }
        }
      }
    }
  }
`);

export const PresetScriptFieldsFragment = graphql(`
  fragment PresetScriptFields on PresetScriptModel {
    id
    name
    description
    script
    parameters {
      name
      type
      required
      defaultValue
      description
    }
    createdAt
    updatedAt
  }
`);

export const ScriptErrorFieldsFragment = graphql(`
  fragment ScriptErrorFields on ScriptErrorModel {
    line
    column
    message
    code
    phase
    originHelper
    hint
    snippet {
      lineNumber
      source
      isErrorLine
    }
    stackFrames {
      phase
      line
      helperName
      description
    }
  }
`);

export const ScriptWarningFieldsFragment = graphql(`
  fragment ScriptWarningFields on ScriptWarningModel {
    line
    column
    message
    code
  }
`);
